import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import CityList from './City/CityList'
import CountryList from './Country/CountryList'
import StateList from './State/StateList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'

const CSCTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('country')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageCountry,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'country')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'country' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Country
                  <hr />
                </span>
              </Link>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.manageState,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'state')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'state' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  State
                  <hr />
                </span>
              </Link>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.manageCity,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'city')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'city' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  City
                  <hr />
                </span>
              </Link>
            )}
          </div>
          <div className='tab-content p-3'>
            <div
              id='country'
              className={`tab-pane fade ${
                activeToggle === 'country' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'country' && <CountryList />}
            </div>

            <div
              id='state'
              className={`tab-pane fade ${
                activeToggle === 'state' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'state' && <StateList />}
            </div>
            <div
              id='city'
              className={`tab-pane fade ${
                activeToggle === 'city' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'city' && <CityList />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CSCTabbing
